import { Platform } from "react-native";

import { createNativeAdapter } from "./nativeAdapter";
import type { StorageAdapter } from "./types";
import { createWebAdapter, requestPersistentStorage } from "./webAdapter";

export { isQuotaError } from "./quota";
export type { HistoryKey, StorageAdapter } from "./types";

let adapter: StorageAdapter | null = null;

/** IndexedDB on web (when available), AsyncStorage everywhere else. */
export function getStorageAdapter(): StorageAdapter {
  if (!adapter) {
    if (Platform.OS === "web" && typeof indexedDB !== "undefined") {
      requestPersistentStorage();
      adapter = createWebAdapter();
    } else {
      adapter = createNativeAdapter();
    }
  }
  return adapter;
}

/** Tests: force an adapter (null restores platform selection). */
export function setStorageAdapter(next: StorageAdapter | null): void {
  adapter = next;
}
